import { RendererService } from './../../components/renderer.service';
import { SceneService } from './../../components/scene.service';
import { OBJModel } from './../../model';
import { Component } from '@angular/core';
import { OBJLoader, Vector3, Object3D, Group } from 'three';
import { EntityComponent } from '../../components/share/entity-component';

@Component({
  selector: 'ng3-obj-loader',
  templateUrl: './obj-loader.component.html',
  styleUrls: ['./obj-loader.component.css'],
})
export class ObjLoaderComponent extends EntityComponent<OBJModel> {
  constructor(sceneService: SceneService, renderer: RendererService) {
    super(sceneService, renderer);
  }
  createEntity(model: OBJModel) {
    const loader = new OBJLoader();
    let result = new Group();
    loader.load('../../../../../resource/ceberus/Cebrus.obj', loadMesh => {
      loadMesh.position.copy(model.center);
      result = loadMesh;
    });
    // const result = new Mesh();
    // result.name = '';
    // result.position.copy(model.center);
    // result.rotation.x = - Math.PI / 2;
    return result;
  }
  updateEntity(model: OBJModel, entity: Group) {
    entity.position.copy(model.center);
    return entity;
  }
  defaultModel() {
    return new OBJModel(
      new Vector3(0, 0, 0)
    );
  }

}
